class PTWaiver {

    constructor(wrapper){

        this.wrapper = wrapper;

        this.checkbox =
            wrapper.querySelector('.pt-waiver__checkbox');

        if(!this.checkbox) return;

        this.init();

    }

    init(){

        this.findButtons();

        this.checkbox.addEventListener(
            'change',
            () => this.update()
        );

        this.update();

    }

    findButtons(){

        const root =
            this.wrapper.closest('form, .cart__sidebar, .drawer__footer-bottom, body');

        this.checkoutButtons = root.querySelectorAll(
            'button[name="checkout"], input[name="checkout"]'
        );

        this.buyNow =
            root.querySelector('.shopify-payment-button');

    }

    update(){

        const accepted = this.checkbox.checked;

        this.checkoutButtons.forEach(button => {

            button.disabled = !accepted;

            button.setAttribute(
                'aria-disabled',
                !accepted
            );

        });

        if(this.buyNow){

            this.buyNow.style.display =
                accepted ? '' : 'none';

        }

    }

}
function initPTWaiver(){

    document
        .querySelectorAll('[data-waiver]')
        .forEach(function(wrapper){

            if(wrapper.ptWaiver) return;

            wrapper.ptWaiver =
                new PTWaiver(wrapper);

        });

}

document.addEventListener(
    'DOMContentLoaded',
    initPTWaiver
);

document.addEventListener(
    'shopify:section:load',
    initPTWaiver
);

new MutationObserver(initPTWaiver).observe(
    document.body,
    {
        childList:true,
        subtree:true
    }
);

/*function initCopyrightWaiver() {

    // Find every waiver on the page
    document.querySelectorAll('.cart-copyright-waiver').forEach(function(wrapper){

        if (wrapper.dataset.initialized) return;
        wrapper.dataset.initialized = "true";

        const checkbox = wrapper.querySelector('.copyright-agreement');

        if (!checkbox) return;

        // Find the nearest checkout button after this waiver
        const container = wrapper.closest('.drawer__footer-bottom, .cart__sidebar, form, body');

        let checkout =
            container.querySelector('button[name="checkout"], input[name="checkout"]') ||
            document.querySelector('button[name="checkout"], input[name="checkout"]');

        if (!checkout) return;

        function update() {
            checkout.disabled = !checkbox.checked;
            checkout.setAttribute('aria-disabled', !checkbox.checked);
        }

        checkbox.addEventListener('change', update);

        update();
    });

}

document.addEventListener('DOMContentLoaded', initCopyrightWaiver);

document.addEventListener('shopify:section:load', initCopyrightWaiver);

new MutationObserver(initCopyrightWaiver).observe(document.body, {
    childList: true,
    subtree: true
});
*/
